module.exports = __webpack_public_path__ + "img/badge_salabam_vac_vadobay.b5c4082a.jpg";